import { PlusOutlined, ProfileOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import SubscriptionModal from "./components/SubscriptionModal";
import SubscriptionCampusesModal from "./components/SubscriptionCampusesModal";

function Subscriptions() {
  const [editingKey, setEditingKey] = useState(null);
  const [subscriptions, setSubscriptions] = useState({});
  const [showSubModal, setShowSubModal] = useState(false);
  const [showCampusesEdit, setShowCampusesEdit] = useState(false);

  const COLUMNS = [
    {
      title: "Name",
      dataIndex: "name",
      width: "200px",
      filterType: "search",
      fixed: "left",
    },
    {
      title: "Price",
      dataIndex: "price",
      width: "100px",
      filterType: "search",
    },
    {
      title: "Offer Price",
      dataIndex: "offer_price",
      filterType: "search",
      width: "150px",
    },
    {
      title: "Validity",
      dataIndex: "validity",
      filterType: "search",
      width: "120px",
      render: (value) => (value ? `${value} days` : "NA"),
    },
    {
      title: "Uses",
      dataIndex: "uses",
      width: "220px",
      render: (value) => {
        return value?.map((item, idx) => (
          <div style={{ fontSize: 9 }}>{idx + 1 + ". " + item.note}</div>
        ));
      },
    },
    {
      title: "Campuses",
      width: "220px",
      dataIndex: "campuses",
      children: [
        {
          title: "Active",
          dataIndex: "active",
          key: "active",
          render: (_, record) =>
            record.campuses?.filter((item) => item.is_active).length,
          width: "80px",
        },
        {
          title: "In-Active",
          key: "in_active",
          dataIndex: "in_active",
          render: (_, record) => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {record.campuses?.filter((item) => !item.is_active).length}
              <Button type="link">
                <ProfileOutlined onClick={() => setShowCampusesEdit(record)} />
              </Button>
            </div>
          ),
          width: "100px",
        },
      ],
    },
    {
      title: "Created Date",
      dataIndex: "date_create",
      width: "150px",
      filterType: "date",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },

    {
      title: "Updated Date",
      dataIndex: "date_modify",
      filterType: "date",
      width: "150px",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowSubModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowSubModal(true);
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    const res = await apiRequest({
      path: apiPaths.subscriptionPlans + "?show_all=true",
    });
    if (!res.error) {
      let plansObj = res.results.reduce((plans, plan) => {
        plans[plan.id + "s"] = plan;
        return plans;
      }, {});
      setSubscriptions(plansObj);
    } else {
      message.error(res.error_description);
    }
  };

  const handleRowSave = async (row) => {
    if (editingKey == null) {
      const res = await apiRequest({
        path: apiPaths.subscriptionPlans,
        method: "POST",
        data: row,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      setSubscriptions({ [res.id + "s"]: res, ...subscriptions });
      setShowSubModal(false);
      return;
    }
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.subscriptionPlans + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    subscriptions[editingKey + "s"] = res;
    setSubscriptions({ ...subscriptions });
    setEditingKey(null);
    setShowSubModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 10,
        }}
      >
        <Tooltip title="Add Subscription">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingKey(null);
              setShowSubModal(true);
            }}
          />
        </Tooltip>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(subscriptions)}
          columns={COLUMNS}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          editHandler={(record) => handleRowEdit(record.id)}
          pagination={false}
        />
      </div>
      {showSubModal ? (
        <SubscriptionModal
          open={showSubModal}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={subscriptions[editingKey + "s"]}
          isUpdate={editingKey != null}
        />
      ) : null}
      {showCampusesEdit ? (
        <SubscriptionCampusesModal
          open={true}
          data={showCampusesEdit}
          onCancel={() => {
            setShowCampusesEdit(false);
          }}
          onDataUpdated={(updatedData) => {
            let updatedSubscriptions = { ...subscriptions };
            updatedSubscriptions[updatedData.id + "s"] = updatedData;
            setSubscriptions({ ...updatedSubscriptions });
            setShowCampusesEdit(false);
          }}
          onAllDataUpdated={() => {
            fetchSubscriptions();
            setShowCampusesEdit(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default Subscriptions;
